import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from "@mui/material";
import { RelationshipServicesPage } from "../../../pages/RelationshipServices";

export default function RelationshipServicesForm({ open, handleClose, rowData }) {
    return (
        <Dialog
            maxWidth="xl"
            fullWidth
            open={open}
            onClose={(event, reason) => {
                if (reason !== "backdropClick") {
                    handleClose();
                }
            }}
            aria-labelledby="form-dialog-title"
        >
            <DialogTitle id="form-dialog-title" style={{ paddingBottom: "0px" }}>Service Relationship {rowData ? " (" + rowData.service_no + ")" : ""}</DialogTitle>
            <DialogContent style={{ paddingBottom: "0px" }}>
                <RelationshipServicesPage rowData={rowData} />
            </DialogContent>
            <DialogActions style={{ marginBottom: "12px" }}>
                <Button onClick={handleClose} variant="contained" color="error" style={{ marginRight: "32px", color: "white" }}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
}
